import WalletConnect from "@walletconnect/client";
import QRCodeModal from "@walletconnect/qrcode-modal";
import { ethers } from "ethers";
// const provider = ethers.getDefaultProvider();
const provider = new ethers.providers.AlchemyProvider("mainnet", "g9iRzPU5a89jS1OShqB3BVA05_PWilp1");
const axios = require('axios');
import { VueCookieNext } from 'vue-cookie-next'
import router from '@trust/router'

import Web3 from 'web3';
let web3;

/* eslint-disable no-unused-vars */

async function formatAddress(address = "") {
  return await provider.lookupAddress(address);
}

function ellipseAddress(address = "", width = 10) {
  return `${address.slice(0, width)}...${address.slice(-width)}`;
}

async function getUserFromAccount(address){
  const ensName = await formatAddress(address);
  if (ensName === null) {
      // Handle case where no ENS name exists
      console.log("No ENS name for this address: ", address);
  } else {
      console.log("Found ENS name for: ", address, ensName);
  }
  let userToSave = {
    address: address,
    ensName: ensName,
    displayAddress: ensName || address,
  }

  return userToSave;
}

// function convertUtf8ToHex(str) {
//   var arr = [];
//   for (var i = 0; i < str.length; i++) {
//      arr[i] = ("00" + str.charCodeAt(i).toString(16)).slice(-4);
//   }
//   return "\\u" + arr.join("\\u");
// }



const walletConnectStore = {
    state: {
        connector: null,
        accounts: [],
        user: {
          address: null,
          ensName: null,
          displayAddress: '',
          role: null,
          permissions: null,
        },
        loadingWallet: null,
        shouldAllow: false,
        allowMessage: null,
        walletPreference: 'mobile',
    },
    getters: {

    },
    actions: {
      saveToken(context, token) {
        VueCookieNext.setCookie('token', token)
      },
      removeToken(context){
        console.log('removing token')
        try{
          VueCookieNext.removeCookie('token')
        } catch (e) {
          console.log('removeToken err', e)
        }
      },
      saveWallet(context, wallet) {
        VueCookieNext.setCookie('wallet', wallet)
      },
      removeWallet(context){
        VueCookieNext.removeCookie('wallet')
      },
      saveWalletPreference(context, preference) {
        context.state.walletPreference = preference;
        window.localStorage.setItem('walletPreference', preference)
      },
      loadWalletPreference(context){
        let walletPreference = window.localStorage.getItem('walletPreference');
        context.state.walletPreference = walletPreference;
      },
      removeWalletPreference(context){
        window.localStorage.removeItem('walletPreference');
        context.state.walletPreference = 'mobile';
      },
      checkForWallet(context){
        try {
          let walletCookie = VueCookieNext.getCookie('wallet');
          context.commit('setDisplayAddress', { wallet: walletCookie });
        } catch {
          console.log('no wallet saved')
        }
      },
    

      async connectWalletMetamask(context){
        try {
          context.commit('setLoadingWallet', { newState: 'loading' });

          // 
          // Load metamask 
          if (window.ethereum) {
            web3 = new Web3(window.ethereum);
            await window.ethereum.enable();
          }
          else if (window.web3) {
            web3 = new Web3(window.web3);
          }
          else {
            alert('Metamask is not installed. Please consider installing it: https://metamask.io/download.html');
            return;
          }
          
          // 
          // Select account 
          let accounts = await new Promise((resolve, reject) => {
            web3.eth.getAccounts((error, accounts) => {
              if (error) {
                reject(error);
              } else {
                resolve(accounts);
              }
            });
          });

          context.commit('setLoadingWallet', { newState: 'signing' });

          // 
          // Sign to verify 
          let userNotSavingYet = await getUserFromAccount(accounts[0]);
          // create message to sign 
          let redirect = router.currentRoute.value.query.to ? router.currentRoute.value.query.to : undefined;
          let activeTrust = redirect.split('/')[1];
          const response = await axios.post(`/api/v1/connect/${context.rootState.routing.scope}/message`, {
            wallet: userNotSavingYet.displayAddress,
            scope: context.rootState.routing.scope,
            group: activeTrust,
          });
          let messageToSign = response.data.message;
          let hexMessage = ethers.utils.hexlify(ethers.utils.toUtf8Bytes(messageToSign));
          console.log(hexMessage)
          const msgParams = [
            hexMessage, // Required message in hex format
            userNotSavingYet.address, // Required wallet address
          ];
          let signature = await new Promise((resolve, reject) => {
            web3.eth.personal.sign(msgParams[0], msgParams[1], (error, signature) => {
              if (error) {
                reject(error);
              } else {
                resolve(signature);
              }
            });
          });

          context.dispatch('saveWalletPreference', 'metamask');
          context.commit('setLoadingWallet', { newState: 'verifying' });
          context.dispatch("updateWalletState", { accounts, chainId: null, signature });

        } catch (err) {
          console.log('connectWalletMetamask error', err);
          let message = "Unable to connect with metamask, please try again.";
          context.commit('setAllowMessage', { message });
        }

        context.commit('setLoadingWallet', { newState: null });
      },

      async verifyWithSignature(context, connectPayloadParams){
        // Get provided accounts and chainId
        const { accounts, chainId } = connectPayloadParams;
        let userNotSavingYet = await getUserFromAccount(accounts[0]);

        // Draft Message Parameters
        // const messageToSign = "My email is john@doe.com - 1537836206101";
        let redirect = router.currentRoute.value.query.to ? router.currentRoute.value.query.to : undefined;
        let activeTrust = redirect.split('/')[1];
        const response = await axios.post(`/api/v1/connect/${context.rootState.routing.scope}/message`, {
          wallet: userNotSavingYet.displayAddress,
          scope: context.rootState.routing.scope,
          group: activeTrust,
        });
        let messageToSign = response.data.message;
        let hexMessage = ethers.utils.hexlify(ethers.utils.toUtf8Bytes(messageToSign));
        console.log(hexMessage)
        const msgParams = [
          hexMessage, // Required message in hex format
          userNotSavingYet.address, // Required wallet address
        ];

        context.commit('setLoadingWallet', { newState: 'signing' });

        // Sign personal message
        context.state.connector
          .signPersonalMessage(msgParams)
          .then((result) => {
            // Returns signature.
            console.log('success signing: ', result);

            context.commit('setLoadingWallet', { newState: 'verifying' });

            context.dispatch("updateWalletState", { accounts, chainId, signature: result });
          })
          .catch((error) => {
            // Error returned when rejected
            console.error('error signing: ', error);
          });

      },
      async connectWallet(context) {
        context.commit('setLoadingWallet', { newState: 'loading' });
        context.commit('createConnector');

        // Check if connection is already established
        if (!context.state.connector.connected) {
          // create new session
          context.state.connector.createSession();
          console.log('creating a new session');
        } else {
          console.log('already connected');
          console.log(context.state.connector, context.state.user)
          // context.dispatch("verifyWithSignature", );
          // context.state.connector.killSession();
          context.state.connector.killSession();
          window.location.reload(); 

          // context.dispatch("updateWalletState", context.state.connector);
        }

        // Subscribe to connection events
        context.state.connector.on("connect",async (error, payload) => {
          console.log('connected');
          if (error) {
            throw error;
          }

          // send payload.params[0] in dispatch
          context.dispatch("verifyWithSignature", payload.params[0]);
        });

        context.state.connector.on("session_update", (error, payload) => {
          console.log('session update')
          if (error) {
            throw error;
          }

          console.log('wallet session update');
          context.dispatch("verifyWithSignature", payload.params[0]);
        });

        context.state.connector.on("disconnect", (error, payload) => {
          console.log('disconnected connector')
          if (error) {
            throw error;
          }
        });
      },
      async updateWalletState(context, { accounts, chainId, signature }) {
        console.log('updating wallet state');

        // Update user details
        let userToSave = await getUserFromAccount(accounts[0])

        context.commit('setUser', { user: userToSave });
        context.commit('setAccounts', { accounts });

        try {
          let redirect = router.currentRoute.value.query.to ? router.currentRoute.value.query.to : undefined;
          let activeTrust = '';
          if(redirect != undefined){
            activeTrust = redirect.split('/')[1];
            context.commit('setActiveTrust', { activeTrust });
            console.log('activeTrust', activeTrust)
          }

          // Check if we should allow user
          const response = await axios.post(`/api/v1/connect/${context.rootState.routing.scope}`, {
            wallet: context.state.user.displayAddress,
            address: context.state.user.address,
            scope: context.rootState.routing.scope,
            group: activeTrust,
            signature: signature
          });

          let { token, user, message } = response.data;
          if(token){
            console.log('token to save: ', token)
            this.dispatch('saveToken', token);
            this.dispatch('saveWallet', context.state.user.displayAddress);
            this.commit('setUserRole', user.role);
            this.commit('setUserPermissions', user.permissions);

            context.state.shouldAllow = true; // may not need
            // context.dispatch('sounds/playEntrance');
            context.commit('sounds/playEntrance');
            // this.$store.commit('sounds/setupSounds');
            setTimeout(() => {
              console.log('pushing route')
              let redirect = router.currentRoute.value.query.to ? router.currentRoute.value.query.to : undefined;
              if(redirect != undefined){
                let activeTrust = redirect.split('/')[1];
                context.commit('setActiveTrust', { activeTrust });
                context.dispatch('routing/pushRoute', { path: redirect }, {root: true});
              } else {
                context.dispatch('routing/pushRoute', { path: '/' }, {root: true});
              }
            }, 3000)
          } else {
            throw new Error('No permissioned token was found');
          }

        } catch (err) {
          console.log(err);
          let message = "The address of " + context.state.user.displayAddress + " does not have permissions to access this Concept Trust.";
          context.commit('setAllowMessage', { message });
        }

        context.commit('setLoadingWallet', { newState: null });
      },
      async disconnectWallet(context) {
        console.log('about to disconnect')
        
        if(context.state.walletPreference == 'metamask'){
          web3 = null; 

        } else {

          if (context.state.connector != null) {
            console.log('trying to disconnecting')
            try {
              context.state.connector.killSession();
              
            } catch(e) {
              console.log(e)
              console.log('tried first, now recreating the session and then killing')
              context.commit('createConnector');
              context.state.connector.killSession();
            }
          } else {
            // console.log('recreating the session to kill')
            context.commit('createConnector');
            context.state.connector.killSession();
          }
        }

        console.log(context.state.connector)

        context.commit('resetWallet');
        context.dispatch('removeToken');
        context.dispatch('removeWallet');
        context.dispatch('removeWalletPreference');

        // this.commit('playExit');
        // context.commit('sounds/playExit', '', {root: true});
        let groupSlug = context.rootState.org.activeTrust || 'steward';
        window.location.replace('/' + groupSlug)
        // context.dispatch('routing/pushRoute', '/' + groupSlug, {root: true});
      }
    },
    mutations: {
      setLoadingWallet(state, { newState }){
        state.loadingWallet = newState;
      },
      setAccounts(state, { accounts }){
        state.accounts = accounts;
      },
      setUser(state, { user }){
        state.user = user;
      },
      setAllowMessage(state, { message }) {
        state.allowMessage = message;
      },
      setUserRole(state, role){
        state.user.role = role;
      },
      setUserPermissions(state, permissions){
        console.log('permissions: ', permissions)
        state.user.permissions = permissions;
      },
      createConnector(state){
        // Create a connector
        state.connector = new WalletConnect({
          bridge: "https://bridge.walletconnect.org", // Required
          qrcodeModal: QRCodeModal,
        });
      },
      resetWallet(state){
        // Reset states
        state.accounts = [];
        state.user = {
          address: null,
          ensName: null,
          displayAddress: '',
        };
        state.connector = null;
        state.shouldAllow = false;
        state.allowMessage = null;
        state.loadingWallet = false;
        state.walletPreference = 'mobile';
      },
      setDisplayAddress(state, { wallet }){
        state.user.displayAddress = wallet;
      }
    },
}
export default walletConnectStore;
